import { motion } from "motion/react"

import styles from "./index.module.scss"

interface LoadingCarProps {
    direction?: number
    immediate?: boolean
}

const LoadingCar = ({ direction = 1, immediate = false }: LoadingCarProps) => {
    return (
        <div className={styles.car}>
            <motion.div
                className={styles.flipContainer}
                animate={{ scaleX: direction }}
                transition={
                    immediate
                        ? { duration: 0 }
                        : { duration: 0.15, ease: "easeInOut" }
                }
            >
                <div className={styles.carExhaust} />
                <div className={styles.carBody} />
                <div className={styles.popup} />
            </motion.div>
        </div>
    )
}

export default LoadingCar
